import { render, staticRenderFns } from "./ProcessLaunchWrapper.vue?vue&type=template&id=58a87ac0&scoped=true&"
import script from "./ProcessLaunchWrapper.vue?vue&type=script&lang=js&"
export * from "./ProcessLaunchWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProcessLaunchWrapper.vue?vue&type=style&index=0&id=58a87ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a87ac0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
